import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps } from '../Link';
import { getLinkStyle } from '../utils/getLinkStyle';
import { getLinkSize } from '../utils/getLinkSize';

export const StyledLink = styled(RouterLink)<LinkProps>`
  ${getLinkStyle}

  :focus-visible {
    color: ${({ theme }) => theme.color.semantic.link.default};
    outline: 2px solid var(--ant-color-primary-border);
    text-decoration: underline;
  }

 ${({ theme, size }) => {
   return css`
    font-size: ${getLinkSize(theme, size)};
  `;
 }}

  ${({ ellipsis }) =>
    ellipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;

export const StyledDisabledLink = styled.span<LinkProps>`
  color: ${({ theme }) => theme.color.semantic.link.disabled};

 ${({ theme, size }) => {
   return css`
    font-size: ${getLinkSize(theme, size)};
  `;
 }}
`;
